define('plugin/google-reviews/view/GoogleReviewsLayoutView',['require','lib/view/LayoutView','lib/view/UnwrapRegion','plugin/google-reviews/view/GoogleReviewsListView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var UnwrapRegion = require('lib/view/UnwrapRegion');
    var GoogleReviewsListView = require('plugin/google-reviews/view/GoogleReviewsListView');

    /**
     * Google Reviews view
     *
     * @class GoogleReviewsLayoutView
     */
    return LayoutView.extend({

        template: '#google_reviews_layout_view',

        regions: {
            'reviews': {
                selector: '#sb_google_reviews_list',
                regionClass: UnwrapRegion
            }
        },

        modelEvents: {
            'change': 'render'
        },

        initialize: function () {
            var _this = this;
            this.reviewsCollection = this.options.reviewsCollection;

            this.listenTo(this.reviewsCollection, 'sync', function (){
                //console.log('sync', this.reviewsCollection);
                _this._showReviewsList();
            });
        },

        _showReviewsList: function() {
            this.showChildView('reviews', new GoogleReviewsListView({
                collection: this.reviewsCollection
            }));
        },

    });

});
